import { render, staticRenderFns } from "./Price.vue?vue&type=template&id=21c6346c&scoped=true"
import script from "./Price.vue?vue&type=script&lang=js"
export * from "./Price.vue?vue&type=script&lang=js"
import style0 from "../../theme/price.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./Price.vue?vue&type=style&index=1&id=21c6346c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c6346c",
  null
  
)

export default component.exports